interface Props { title: string; description?: string }

export function SectionHeader({ title, description }: Props) {
  return (
    <header className="mb-4">
      <h2 className="text-base font-bold text-ink">{title}</h2>
      {description && <p className="text-sm text-slate-500 mt-0.5">{description}</p>}
    </header>
  );
}

interface FieldProps { label: string; hint?: string; htmlFor?: string; children: React.ReactNode }

export function Field({ label, hint, htmlFor, children }: FieldProps) {
  return (
    <label htmlFor={htmlFor} className="block">
      <span className="block text-xs font-semibold text-slate-700 mb-1">{label}</span>
      {children}
      {hint && <span className="block text-[11px] text-slate-500 mt-1">{hint}</span>}
    </label>
  );
}
